<template>
  <div>
    <v-card @click.stop="dialog = true" class="storyCard">
      <v-img class="storyImage" :lazy-src="emptyPhoto" :src="mainPhotoUrl"/>
      <div class="storyCardName">{{name}}</div>
      <!-- <v-img v-else contain class="storyImage" :src="emptyPhoto"/> -->
    </v-card>

    <v-dialog v-model="dialog" max-width="1000" height="5">
      <v-card class="dialogFlex">
        <div class="dialogX" @click="dialog = false">
          <v-icon>close</v-icon>
        </div>
        <v-card-text>
          <div style="font-weight: 400; font-size: 1.5rem; ">{{ name }}</div>
          <div>
            <swiper :options="swiperOptionTop"  class="gallery-top pt-3" ref="swiperTop">
              <swiper-slide v-for="(image, index) in photos" :key="index" class="slide-img">
                <v-img contain :max-height="ourMaxHeight" :src="image.photoUrl" alt/>
                <div
                  style="font-size: 1.2rem; width: 100%; text-align: center; margin-top: 4px"
                >{{ image.photoCaption }}</div>
              </swiper-slide>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
            </swiper>

            <!-- <v-carousel hide-delimiters>
              <v-carousel-item v-for="(item,i) in photos" :key="i" :src="item.photoUrl">

                <v-responsive dark style="height: 100%">
                  <v-container fill-height>
                    <v-layout align-end>
                      <v-flex>
                        <span class="subheading storyCardName">{{ item.photoCaption }}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-responsive>
              </v-carousel-item>
            </v-carousel>-->
          </div>

          <v-layout justify-center align-center class="dialogAudioStuff">
            <v-flex>
              <div style="padding: 2rem;">
                <audio ref="audio" controls>
                  <source :src="audio" type="audio/mpeg">
                </audio>
              </div>
            </v-flex>
            <v-flex style="padding: 2rem 0;">
              <div v-if="name == 'Firdausa Akhtar'" ref="lyrics">
                [00:01.00] Firdausa's Mother-in law: It was evening prayer's azaan time, quarter to seven,
                [00:03.00] we were here, and they were there (at their house),
                [00:06.00] she had gone outside the house (to wash the utensils) carrying two cups.
                [00:09.00] hers and her daughters' and a cooking bowl with a spatula
                [00:13.50] Just before that her husband had returned from the shop
                [00:17.00] and she had served tea to him and her son. While leaving the room she had told
                [00:22.00] her husband that her uncle and aunt are visiting tomorrow,
                [00:26.00] she need money to buy some groceries to cook for them.
                [00:30.00] He told her not to worry and that he will but it himself for them
                [00:34.00] She agreed, giving him a smile and went about to clean the cups.
                [00:40.00] and then there was loud bang, we even heard it here.
                [00:43.00] Everything seemed to be shaking.
                [00:47.00] I told my family here, firing is going on in Shadi Margh area.
                [00:50.00] We phoned the children and inquired about it, they said, we don't have any idea.
                [00:54.00] Maybe it is practice fire, we are siting indoors.
                [00:59.00] We didn't know what was happening.
                [01:03.00] That house had a boundary wall made up of tin sheets.
                [01:00.00] And exactly opposite the courtyard tap there is a big hole in the tin sheet.
                [01:10.00] That is where the bullet entered and hit her.
                [01:18.00] This is only what we know, what else we can say.
                [01:21.00] We have all turned mad here, day and night thinking about her only.
                [01:28.00] We feel her face; her shadow is right in front of us. Every day and every night.
                [01:35.00] What do we do now.
                [01:39.00] Everyone tells us, come what may you cannot get her back.
                [01:44:00] Her husband is my youngest son
                [01:50.00] he is suffering from depression now and is on medication.
                [01:55.00] Every evening when he returns from work,
                [01:57.50] he keeps looking at her photos on his mobile and keeps crying,
                [02:00.00] then looks helplessly at his children. What can he do?
                [02:03.00] they have lost their mother. Everyone needs mother.
                [02:07.50] I lost mine, I too miss her, one needs parents even when one turns old.
                [02:15.00] Her daughter was a baby then.
                [02:20.00] And Firdausa would not let her out of her sight even for a minute.
                [02:26.00] I try to take care of her now, but she misses her mother.
                [02:31.00] Her son goes daily to her grave.
                [02:37.00] And he just sits there staring at the ground.
                [02:42.00] A neighbor asked me about his whereabouts yesterday
                [02:47.00] I said that he might be playing around.
                [02:50.00] The neighbor said, 'No, the boy is at his mother's grave'.
                [02:56.00] I rushed to graveyard and he was just sitting there alone.
                [03:02.00] Staring at her grave with a sad look on his face.
                [03:05.00] I hugged him and I said, I will give you my life, why are you here? Come home.
                [03:08.00] He said grandma let me be here, you go home.
                [03:11.00] Then he said, 'Grandma, you think I go out and play around every day?
                [03:14.00] I like to come here and sit instead'.
                [03:23.00] She was a different person, beautiful, young and well-mannered.
                [03:28.00] So civilized and soft-spoken, She was like a pearl.
                [03:31.00] What do we do now?
              </div>
              <div v-else-if="name == 'Haseeb Ahmad Khan'" ref="lyrics">
                [00:00.01] Haseeb's Father: I had asked him to join me as my helper,
                [00:03.00] but he told me, "Father, I didn't like this driving business."
                [00:06.00] He said this to me clearly when I met him at Kot Bhalwal jail.
                [00:09.00] I asked him what you will do then.
                [00:11.00] I don't have 10 or 20 lakh rupees to give you
                [00:14.00] and say take it and start any business.
                [00:17.00] On this he regretted, said sorry and assured me
                [00:21.00] that he would not give me any chance to complain from then on.
                [00:26.00] He started working as painter, where worked for 4-5 days
                [00:30.00] and earned about 2000-2500 rupees.
                [00:33.00] My wife told me he has got this much money
                [00:36.00] and he is not giving me anything out of it.
                [00:40.00] I told her don't bother him.
                [00:43.00] Let him earn for his personnel expenses only, this way
                [00:46.00] he will be better, and no one will say he is wanderer.
                [00:53.00] I told her be calm let him spend whatever he earns.
                [01:00.00] He even told his mother that father has told me to earn just for myself,
                [01:06.00] don't pay us but to work for myself.
                [01:09.00] And then Just after 14 days, he died.
                [01:16.00] He was very affectionate, if any friend would have asked
                [01:21.00] him to walk to Srinagar from Baramulla, he would do it.
                [01:25.00] Without using any sort of transport, where one would pay
                [01:30.00] rupees twenty to a bus and go Srinagar,
                [01:33.00] but if a friend asked him to do it for them, he would just walk.
                [01:37.00] We don't have any guarantee of life here.
                [01:39.00] Not even within the four walls of home.
                [01:41.00] Whenever I leave for Delhi, Mumbai or Jammu for my work,
                [01:46.00] all the way I keep thinking about the security of my family
                [01:50.00] because I have seen my son being killed in front of me.
                [01:53.00] I am always apprehensive about the lives of my other family
                [01:56.00] members. They even can kill me, it is not a big thing for them.
                [01:58.00] We know his killers too, a militant who lives close by.
                [02:03.00] From his father's shop we brought grocery items for the customary meals
                [02:08.00] for four days of mourning.
                [02:15.00] But at that time we were not aware that his son had killed Haseeb
              </div>
              <div v-else-if="name == 'Liyaqat Ahmad Dar'" ref="lyrics">
                [00:00.05] Mother: He was a student and had just cleared his Class XII exams with very high marks,
                [00:06.00] but it was not destined. We gave him INR 3000 as he had to buy some books.
                [00:12.40] He wanted to join a coaching center in the city at Parraypora and by the grace of God
                [00:18.00] he had qualified the entrance test there in the his very first attempt,
                [00:26.00] but they told him to join after passing the 12th, class, which he did and
                [00:30.00] now he was going both the places. He had chosen the tough subjects which he passed in very first year.
                [00:35.60] When he cleared his exams, they came from Parrypora to congratulate me.
                [00:40.00] They laureated him with garlands and medals.
                [00:44.50] He had no idea that some encounter was going on that side and
                [00:50.00] they (Army) just targeted him firing indiscriminately. They were seven boys,
                [01:00.00] students just passing by and shot dead.
                [01:05.00] (Mother starts wailing when a photograph of him is show to us)
                [01:11.00] Your mother would sacrifice herself for you my son, immolate herself, on your photograph!
                [01:20.00] You are my backbone, I would sacrifice my eyesight of my being for you, oh my soul, apple of my eye.
                [01:30.00] Oh, my youth! I would give you my liver, sacrifice my life for your existence.
                [01:40.00] Parveen would immolate herself for you oh my backer, my son!
                [01:47.00] I would sacrifice my eyesight for you my son.
                [01:51.00] I have lost my mental balance my son. I have turned insane. Oh, my son!
                [02:01.00] What happened to you my son?
                [02:09.00] You left all your clothes behind here, what do I do with them my son.
                [02:20.00] All your books, will they go to waste, oh my son!
                [02:35.00] How will I get you back? How will I find you? Oh, my son!
                [02:49.00] These clothes you bought for ten thousand rupees and
                [02:53.00] all those are sprawled around here only. Oh, my son!
                [02:57.00] Oh my god!
                [03:04.00] Daughter: Maa let them have the tea. You're not letting them drink their tea.
                [03:08.00] Mother: Who had any idea that this will happen to me? Mom will immolate herself for you,
                [03:18.00] for these school bags my son, oh my son.
                [03:22.00] Daughter: Maa look I had to show it to them that is why I bought it here.
                [03:28.00] If you keep crying like this, I will never show it (his photograph) to you again.
                [03:36.00] Mother: He was the best. The best one. Physically fit, not weak. A big helping hand to his father.
                [03:43.00] He used to study and also help his father in carrying the milk from one place to another.
                [03:51.00] He was the best one with firm hands and feet.
                [03:56.00] Please have some more tea.
              </div>
              <div v-else-if="name == 'Mushtaq Ahmad Mir'" ref="lyrics">
                [00:00.00] Habla Begum (w/o Mustaq Ahmad Mir)
                [00:01.00] I used to run a tailoring shop at my parents' house,
                [00:03.00] where I had many workers and he was one among them.
                [00:05.00] One day he proposed to me and said,
                [00:07.00] "Some of my friends have taken government jobs,
                [00:10.00] a few have opted for jihad, but I want to carry you in my lap
                [00:13.00] all my life and that would be my way of Jihad".
                [00:16.00] I told him, look I am disabled, I cannot marry you
                [00:28.00] but he said, "I would go to any extent to care for you
                [00:20.00] and will carry you on my shoulders all my life."
                [00:22.00] Then we got married, I came here with him.
                [00:24.00] After two years we had our first child.
                [00:26.00] At that stage he did everything for me, nursing me.
                [00:28.00] He even used to change my cloths.
                [00:30.00] He used to buy new cloths for me with a lot of love too.
                [00:32.00] He used to tell me that, "You should not have less number of dresses
                [00:34.00] than any other woman."
                [00:36.00] These are the dresses these girls took out
                [00:38.00] from the boxes yesterday, look at them.
                [00:41.00] He had brought these for me, and I am yet to wear them.
                [00:44.00] He was always saying that you must dress up nicely,
                [00:47.00] the way other (normal) women are dressing up.
                [00:50.00] Disability shouldn't come in your way.
                [00:53.00] Many people told him that she is physically challenged
                [00:56.00] and that he should go and get married to someone else,
                [00:59.00] but he always replied by saying "Don't talk to me like that,
                [01:03.00] for me there is no one like her".
                [01:06.00] He always pampered me, never misbehaved and was never rude.
                [01:15.00] He used to tell me that when I die,
                [01:18.00] he would give me the Ghusl (obligatory bath) first and then only let people
                [01:22.00] know that I have passed away.
                [01:23.00] On hearing this I used to cry and tell him, I am physically challenged,
                [01:26.00] people will pass sarcastic comments.
                [01:28.00] I never knew that he is going to leave me
                [01:31.00] leave me forever like this.
              </div>
              <div v-else-if="name == 'Ubaid Manzoor Lone'" ref="lyrics">
                [00:00.01] Ubaid's Mother: He was studying in 11th standard.
                [00:02.00] Day before there was rumor that there is Hartal (shutdown)
                [00:04.00] on that day.
                [00:06.00] But in the morning it was like a normal day so he along with
                [00:08.00] his classmates left for the school.
                [00:11.00] When they reached Baramulla everything including schools were closed,
                [00:14.00] so they turned back.
                [00:18.00] On their way back to home few kids were bathing
                [00:26.00] in a stream ahead of that spot where some youngsters
                [00:30.00] were pelting stones at the security forces.
                [00:37.00] Personnel of Special Task Force and the Army were
                [00:43.00] chasing the boys in same direction.
                [00:52.00] His classmates ran much faster than him, but he couldn't
                [00:58.00] because of his physique. He was bulky so he couldn't run fast.
                [01:03.00] He had such a physique that no one used to believe
                [01:05.00] that he was just 16 years old.
                [01:08.00] Even the doctors at city hospital asked us
                [01:12.00] how many children he has got?
                [01:14.00] He used to look like an older man.
                [01:16.00] So he couldn't run, he was just walking, and army fired at him.,
                [01:21.00] The bullet pierced his heart.
                [01:26.00] As the news came that Ubaid been injured,
                [01:29.00] people came screaming in large numbers and
                [01:32.00] we rushed him to city hospital, where he was in coma for fifteen days.
                [01:37.00] He was highly studious and a workaholic. He used to take care of household,
                [01:44.00] was good in his studies and even good at sports.
                [01:52.00] He used to play Kabaddi as well as many other games.
                [02:00.00] He represented his school in many sports events.
                [02:09.00] Before this incident he told us that the school is sending him Jammu
                [02:15.00] for fifteen days to participate in some tournament.
                [02:18.00] His father happily gave him three thousand rupees for this but
                [02:23.00] after some days he suddenly changed his mind and
                [02:27.00] dropped the idea of participating in that tournament.
                [02:30.00] Maybe because Allah was waiting for him in heaven.
                [02:34.00] Before that he had gone for many such sports events.
                [02:41.00] But this is now just our misfortune.
                [02:46.00] We used to be very cautious about everything when he was at home.
                [02:52.00] Because he was very particular about his food and
                [02:56.00] not like my other son who doesn't mind what food he is being offered.
                [03:02.00] Whenever he entered the kitchen and smelled that
                [03:05.00] only vegetarian food like Haakh (Collard greens) is being prepared,
                [03:07.00] he used to say keep it for yourself today I am not going to have it.
                [03:10.00] He never liked Haakh and was fond of mutton and yes, he also
                [03:14.00] used to like lentils and some vegetables like tomato and peas.
                [03:18.00] He loved eating all that.
              </div>

              <div v-else ref="lyrics">Error</div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RabbitLyrics from "rabbit-lyrics";

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  props: ["audio", "photos", "mainPhotoUrl", "subTitleText", "name"],
  mounted() {
    // console.log(this.$refs.lyrics)
    new RabbitLyrics({
      element: this.$refs.lyrics,
      mediaElement: this.$refs.audio,
      viewMode: "mini"
    });
    this.$refs.audio.pause();
  },
  data() {
    return {
      dialog: false,
      emptyPhoto: require("../../assets/nophoto.jpeg"),
      swiperOptionTop: {
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {},
  computed: {
    ourMaxHeight() {
      if(window.innerWidth >= 1900) {
        return 500
      } else if (window.innerWidth < 1200 && window.innerWidth >= 900 ) {
        return 300
      } else if (window.innerWidth < 900 && window.innerWidth >= 400 ) {
        return 200
      } else {
        return 100
      }
    }
  },
  watch: {
    dialog(newValue, oldValue) {
      this.$refs.audio.pause();
    }
  }
};
</script>

<style lang="stylus" scoped>
.dialogAudioStuff {
}

.dialogFlex {
  margin: 0 1rem 1rem 0;
  font-size: 1.4rem;
  position: relative;
}

.dialogX {
  position: absolute;
  right: 0;
  top: 0;
  margin: 1rem;
  padding: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease-out;

  &:hover {
    background-color: #333333;
    transition: background-color 0.6s ease;
  }
}

.dialogSocialIcons {
  font-size: 1.4rem;
}

.dialogHr {
  margin: 6px 0;
  opacity: 0.4;
}

.dialogHeading {
  font-size: 20px;
  font-weight: 550;
  padding: 2px 4px;
  margin-right: 2px;
}

.dialogIncidentReport {
  margin-left: 0.1rem;
}

.dialogImage {
  max-width: 20rem;
  max-height: 40rem;
  transform: translateY(14px);
}

.storyCard {
  margin: 1.5rem;
  position: relative;
}

.storyImage {
  // -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  // filter: grayscale(100%);
  // transition: filter 0.6s ease;
  max-width: 30rem;
  max-height: 30rem;

  // &:hover {
  //   -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
  //   filter: grayscale(0%);
  //   transition: filter 0.5s ease;
  // }
}

.storyCardHelpText {
  position: relative;
}

.storyCardName {
  position: absolute;
  bottom: 0rem;
  width: 100%;
  padding-left: 1rem;
  font-weight: 500;
  font-size: 1.34rem;
  background-color: rgba(#777777, 0.7);
  color: white;
}

.personClickedDialog {
  max-width: 10px;
  width: 10px;
}

.swiper-button-next {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23e53d3d'%2F%3E%3C%2Fsvg%3E") !important;
}

.swiper-button-prev {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23e53d3d'%2F%3E%3C%2Fsvg%3E") !important;
}


/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .storyCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1.34rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .storyCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1.34rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .storyCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1.34rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .storyCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1.34rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1270px) {
  .storyCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}
@media only screen and (min-width: 1761px) {
  .storyCardName {
    position: absolute;
    bottom: 0rem;
    width: 100%;
    padding-left: 1rem;
    font-weight: 500;
    font-size: 1.32rem;
    background-color: rgba(#777777, 0.4);
    color: white;
  }
}
</style>
